<template>
    <div>
        <h2 v-if="obData.messages" class="def-header-2">{{result.messages.title}}</h2>
        <div class="page-sale__grid" v-for="(item, i) in obData.items">
            <sale-card
                       v-if="item"
                       :key="i" :result="item" :messages="obData.messages"
            />
        </div>
        <Pagination
            :result="obData.pagination"
            @triggerGetPage="getPage"
            @triggerAddMore="addMore"
        />
    </div>
</template>

<script>
    export default {
        name: 'page-sale',
        selector: '.page-sale',
        props: {
            result: {
                type: Object,
                default: () => ({
                    items: [
                        {
                            picture: {
                                desktop:{
                                    src: '/local/templates/love-you/images/front-end/sale/poster.png',
                                    alt: 'poster'
                                },
                                mobile: {
                                    src: '/local/templates/love-you/images/front-end/sale/poster-mobile.png',
                                    alt: 'poster'
                                }
                            },
                            name: 'WOW вікенд! До -30% на всі підвіски та кольє',
                            daysDeft: '3алишилось',
                            day: '2 дні',
                            detailPage: '/text/',
                            over: false
                        },
                        {
                            picture: {
                                desktop:{
                                    src: '/local/templates/love-you/images/front-end/sale/poster.png',
                                    alt: 'poster'
                                },
                                mobile: {
                                    src: '/local/templates/love-you/images/front-end/sale/poster-mobile.png',
                                    alt: 'poster'
                                }
                            },
                            name: 'WOW вікенд! До -30% на всі підвіски та кольє',
                            daysDeft: 'Закінчилась :(',
                            detailPage: '/text/',
                            over: true
                        },
                        {
                            picture: {
                                desktop:{
                                    src: '/local/templates/love-you/images/front-end/sale/poster.png',
                                    alt: 'poster'
                                },
                                mobile: {
                                    src: '/local/templates/love-you/images/front-end/sale/poster-mobile.png',
                                    alt: 'poster'
                                }
                            },
                            name: 'WOW вікенд! До -30% на всі підвіски та кольє',
                            daysDeft: '3алишилось',
                            day: '2 дні',
                            detailPage: '/text/',
                            over: false
                        },
                        {
                            picture: {
                                desktop:{
                                    src: '/local/templates/love-you/images/front-end/sale/poster.png',
                                    alt: 'poster'
                                },
                                mobile: {
                                    src: '/local/templates/love-you/images/front-end/sale/poster-mobile.png',
                                    alt: 'poster'
                                }
                            },
                            name: 'WOW вікенд! До -30% на всі підвіски та кольє',
                            daysDeft: '3алишилось',
                            day: '2 дні',
                            detailPage: '/text/',
                            over: false
                        },
                        {
                            picture: {
                                desktop:{
                                    src: '/local/templates/love-you/images/front-end/sale/poster.png',
                                    alt: 'poster'
                                },
                                mobile: {
                                    src: '/local/templates/love-you/images/front-end/sale/poster-mobile.png',
                                    alt: 'poster'
                                }
                            },
                            name: 'WOW вікенд! До -30% на всі підвіски та кольє',
                            daysDeft: '3алишилось',
                            day: '2 дні',
                            detailPage: '/text/',
                            over: false
                        },
                        {
                            picture: {
                                desktop:{
                                    src: '/local/templates/love-you/images/front-end/sale/poster.png',
                                    alt: 'poster'
                                },
                                mobile: {
                                    src: '/local/templates/love-you/images/front-end/sale/poster-mobile.png',
                                    alt: 'poster'
                                }
                            },
                            name: 'WOW вікенд! До -30% на всі підвіски та кольє',
                            daysDeft: '3алишилось',
                            day: '2 дні',
                            detailPage: '/text/',
                            over: false
                        },
                    ],
                    messages: {
                        title: 'Акції',
                        detailText: 'Детальніше'
                    },
                    pagination: {
                        pagingKey: "PAGEN_1",
                        pageCount: 40,
                        pageNumber: 1,
                        pageSize: 12
                    },
                })
            }
        },
        data() {
            return {
                obData: this.result
            }
        },
        methods: {
            /**
             * Тут происходит склеивание данных успешного ответа Ajax запроса
             */
            compareResponse(response){
                const data = response.data;

                if (this.debug) {
                    console.log('ajaxResponse', response);
                }

                for (let key in data.items) {
                    this.obData.items.push(data.items[key]);
                }

                this.obData.pagination = data.pagination;
            },
            /**
             * Имитация перехода на нужную страницу
             */
            replaceResponse(response){
                this.obData = response.data;
            },
            replaceItems(response){
                this.obData.items.forEach((item, i) => {
                    if (!response.data.items.find(el => el.id == item.id)) {
                        delete this.obData.items[i];
                    }
                })
            },
            /**
             * Метод по которому происходит Ajax загрузка данных (добавление)
             */
            addMore () {
                if (this.obData.pagination.pageCount > this.obData.pagination.pageNumber) {
                    axios.get(window.location.href, {
                        params: {
                            api: 'y',
                            [this.obData.pagination.pagingKey]: ++this.obData.pagination.pageNumber,
                        }
                    })
                        .then(this.compareResponse)
                        .catch(function (error) {
                            console.log(error);
                        })
                        .then(function () {
                            console.log('always executed');
                        });

                }
            },
            /**
             * Метод по которому происходит Ajax переход на нужную страницу
             * @param numb
             */
            getPage(url) {
                axios.get(url, {
                    params: {
                        api: 'y',
                    }
                })
                .then(this.replaceResponse)
                .catch(function (error) {
                    console.log(error);
                });
            },
            updateItems(url) {
                axios.get(url, {
                    params: {
                        api: 'y',
                    }
                })
                    .then(this.replaceItems)
                    .catch(function (error) {
                        console.log(error);
                    });
            },
        },
    }
</script>

<style lang="scss">
    .page-sale{
        &__grid{
            display: grid;
            grid-row-gap: 24px;
            @include point-md{
                grid-row-gap: 40px;
            }
        }
    }
</style>